import { isMobile, handleNavigationMenu } from "../../../js/utils";

(() => {
  const BRHNavigation = () => {
    const init = () => {
      const navigationMenu = document.querySelectorAll(".js-navigation-menu");
      const burger = document.querySelector(".js-burger");
      navigationMenu?.forEach((element) => {
        element.addEventListener("click", function () {
          const openItemsClass = ".js-navigation-menu.mod--submenu-open";
          handleNavigationMenu(openItemsClass);
          element.classList.toggle("mod--submenu-open");
          burger.classList.add("mod--submenu-open");
        });
        const goBackSubmenu = element.querySelector(".js-navigation-menu__submenu .js-go-back-navigation");
        goBackSubmenu?.addEventListener("click", function (event) {
          event.stopPropagation();
          element.classList.toggle("mod--submenu-open");
          burger.classList.remove("mod--submenu-open");
        });
      });

      if (!isMobile()) {
        const scrollContainers = document.querySelectorAll(".cmp-navigation__group .brh-navigation-menu__group");
        let isDragging = false;
        let startX, scrollLeft;

        const handleClickableItems = ({ scrollContainer, action }) => {
          scrollContainer?.forEach((item) => {
            item.style.pointerEvents = action;
          });
        };

        scrollContainers?.forEach((container) => {
          container.addEventListener("mousedown", (e) => {
            isDragging = true;
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
          });

          document.addEventListener("mouseleave", () => {
            isDragging = false;
          });

          document.addEventListener("mouseup", (e) => {
            isDragging = false;
            e.preventDefault();
            setTimeout(() => {
              const items = container.querySelectorAll("a.brh-navigation-menu__item-link");
              handleClickableItems({ scrollContainer: items, action: "auto" });
            }, 200);
          });

          container.addEventListener("mousemove", (e) => {
            if (!isDragging) {
              return;
            }
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX) * 2;
            container.scrollLeft = scrollLeft - walk;
            const items = container.querySelectorAll("a.brh-navigation-menu__item-link");
            handleClickableItems({ scrollContainer: items, action: "none" });
          });
        });
      }
    };
    init();
  };
  document.addEventListener("DOMContentLoaded", BRHNavigation);
})();
